import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, first, map, Observable, tap } from 'rxjs';
import { MotivationalMessage, MotivationalMessageCustomSet, TspMessageRepository } from '../core';
import { BaseService } from './base.service';


/**
 * This service handles motivational messages.
 */
@Injectable({ providedIn: 'root' })
export class MessageService extends BaseService {

	private readonly msgRepo = inject(TspMessageRepository);

	private readonly _set = new BehaviorSubject<MotivationalMessage[]>([]);


	/**
	 * Get motivational message set.
	 */
	getSet(): Observable<MotivationalMessage[]> {
		if (this._set.value?.length) return this._set.asObservable().pipe(first());
		return this.msgRepo.getDefaultSet().pipe(
			map(res => this._handleApiResponse(res)),
			tap(set => this._set.next(set ?? []))
		);
	}

	/**
	 * Get list of custom set.
	 */
	getCustomSet(userId: string): Observable<MotivationalMessageCustomSet[]> {
		return this.msgRepo.getCustomSetList(userId).pipe(
			map(res => this._handleApiResponse(res))
		);
	}

	/**
	 * Save custom set.
	 */
	saveCustomSet(name: string, motMessageIds: number[]): Observable<void> {
		const customSet: MotivationalMessageCustomSet = { name: name, enabledSet: motMessageIds };
		return this.msgRepo.saveCustomSet(customSet).pipe(
			map(res => this._handleApiResponse(res))
		);
	}

	/**
	 * Rename custom set.
	 */
	renameCustomSet(name: string, newName: string): Observable<void> {
		return this.msgRepo.renameCustomSet(name, newName).pipe(
			map(res => this._handleApiResponse(res))
		);
	}

	/**
	 * Delete custom set.
	 */
	deleteCustomSet(name: string): Observable<void> {
		return this.msgRepo.deleteCustomSet(name).pipe(
			map(res => this._handleApiResponse(res))
		);
	}

}
